import styles from "./pageContainer.module.css";
import Loader from "./Loader";

const PageContainer = ({ children, header, isLoading }) => {
  if (isLoading) {
    return (
      <div style={{ margin: "auto" }}>
        <Loader small />
      </div>
    );
  }

  return (
    <div className={styles.pageContainerWithHeader}>
      {!!header ? <h1>{header}</h1> : null}
      <div className={styles.pageContainer}>{children}</div>
    </div>
  );
};

export default PageContainer;
